export default function CTA() {
  return (
    <section
      id="contact"
      className="bg-surface text-center py-24 border-t border-line"
    >
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Get started
        </p>
        <h2 className="font-bricolage text-[clamp(1.9rem,3vw,2.4rem)] mb-[0.85rem] text-ink">
          See OneDPDP on your programme.
        </h2>
        <p className="text-slate max-w-[34rem] mx-auto mb-8 text-[1.05rem]">
          See the unified platform, data discovery, AI capabilities and Policy
          Store — on a scenario built for your industry.
        </p>
        <a
          href="mailto:sales@onedpdp.com"
          className="inline-block bg-teal hover:bg-teal-bright text-white font-semibold rounded px-8 py-[0.85rem] text-[1.02rem] transition-all hover:-translate-y-px"
        >
          Request a demo
        </a>
      </div>
    </section>
  );
}
